module.exports = __webpack_public_path__ + "static/media/benefits-hero.0d7da279.jpeg";